export enum TrainBrandEnum {
  branded = 'Фирменный',
  notBranded = 'Не фирменный',
}

export enum PeriodicityNameEnum {
  daily = 'Ежедневно',
  evenDays = 'По чётным',
  oddDays = 'По нечётным',
  everyOtherDay = 'Через день',
  byDayOfTheWeek = 'По дням недели',
  byDate = 'По датам',
  inQuantityDays = 'Через n дней',
}

export enum PeriodicityMnemonicEnum {
  daily = 'periodicity.daily',
  evenDays = 'periodicity.on_even_days',
  oddDays = 'periodicity.on_odd_days',
  everyOtherDay = 'periodicity.in_one_day',
  byDayOfTheWeek = 'periodicity.by_day_of_week',
  byDate = 'periodicity.by_dates',
  inQuantityDays = 'periodicity.in_quantity_days',
}

export enum TrainStatusMnemonicEnum {
  planning = 'approval_status.planning',
  approval = 'approval_status.approval',
  approved = 'approval_status.approved',
  preApproved = 'approval_status.pre_approved',
}

export const TRAIN_STATUS_NAME_MAP = {
  [TrainStatusMnemonicEnum.planning]: 'Планирование',
  [TrainStatusMnemonicEnum.approval]: 'Согласование',
  [TrainStatusMnemonicEnum.approved]: 'Утверждение',
  [TrainStatusMnemonicEnum.preApproved]: 'Предварительное утверждение',
};

export const PERIODICITY_NAME_MAP: Readonly<Record<string, string>> =
  Object.freeze({
    [PeriodicityMnemonicEnum.daily]: PeriodicityNameEnum.daily,
    [PeriodicityMnemonicEnum.evenDays]: PeriodicityNameEnum.evenDays,
    [PeriodicityMnemonicEnum.oddDays]: PeriodicityNameEnum.oddDays,
    [PeriodicityMnemonicEnum.everyOtherDay]: PeriodicityNameEnum.everyOtherDay,
    [PeriodicityMnemonicEnum.byDayOfTheWeek]:
      PeriodicityNameEnum.byDayOfTheWeek,
    [PeriodicityMnemonicEnum.byDate]: PeriodicityNameEnum.byDate,
    [PeriodicityMnemonicEnum.inQuantityDays]:
      PeriodicityNameEnum.inQuantityDays,
  });

export enum PeriodicitySeasonEnum {
  everyYear = 'Круглогодичный',
  summer = 'Сезонный летний',
  winter = 'Сезонный зимний',
  once = 'Разового назначения',
  special = 'По особому указанию',
}

export enum ScheduleInsertRowModeEnum {
  end = 0,
  above,
  below,
}

export enum ScheduleModalEnum {
  station = 'station',
  stencil = 'stencil',
  copySchedule = 'copySchedule',
}

export enum ScheduleStencilModalSteps {
  step1 = 0,
  step2,
}

export enum TrainDirectionNameEnum {
  direct = 'Прямое',
  reverse = 'Обратное',
  both = 'В обоих направлениях',
}

export enum TrainDirectionMnemonicEnum {
  direct = 'direction.direct',
  reverse = 'direction.reverse',
  both = 'direction.both',
}

export const TRAIN_DIRECTION_NAME_MAP: Readonly<Record<string, string>> =
  Object.freeze({
    [TrainDirectionMnemonicEnum.direct]: TrainDirectionNameEnum.direct,
    [TrainDirectionMnemonicEnum.reverse]: TrainDirectionNameEnum.reverse,
    [TrainDirectionMnemonicEnum.both]: TrainDirectionNameEnum.both,
  });

export enum CarriageGroupPositionEnum {
  head = 'Голова',
  tail = 'Хвост',
  main = 'Основная',
}

export enum CarriageGroupPositionMnemonicEnum {
  head = 'carriage_group_position.head',
  tail = 'carriage_group_position.tail',
  main = 'carriage_group_position.main',
}

export const CARRIAGE_GROUP_POSITION_MAP: Readonly<Record<string, string>> =
  Object.freeze({
    [CarriageGroupPositionMnemonicEnum.head]: CarriageGroupPositionEnum.head,
    [CarriageGroupPositionMnemonicEnum.tail]: CarriageGroupPositionEnum.tail,
    [CarriageGroupPositionMnemonicEnum.main]: CarriageGroupPositionEnum.main,
  });

export enum CarriageGroupStatusMnemonicEnum {
  pending = 'carriage_group_sign.pending',
  imported = 'carriage_group_sign.imported_into_schemas',
  exported = 'carriage_group_sign.exported_to_schemas',
}

export enum MnemonicGroupsEnum {
  approvalStatus = 'approval_status',
  carriageGroupStatus = 'carriage_group_status',
  carriageGroupPosition = 'carriage_group_position',
  carriageGroupSign = 'carriage_group_sign',
  periodicity = 'periodicity',
  rollingStockType = 'rolling_stock_type',
  regulatorySector = 'regulatory_sector',
  seatType = 'seat_type',
  carriageAdditionalParameter = 'carriage_additional_parameter',
  direction = 'direction',
  infrastructurBelongingTerminus = 'infrastructure_belonging_terminus',
  mvpsTypesRate = 'mvps_types_rate',
  locomotiveServiceNamesEmpiricalParameters = 'locomotive_service_names_empirical_parameters',
  userStructuralUnits = 'user_structural_units',
  trainsPostalBaggageMethodConsecution = 'trains_postal_baggage_method_consecution',
  railwayAdministrationInternational = 'railway_administration_international',
}

export enum RollingStockTypeEnum {
  nps = 'rolling_stock_type.nps',
  mvps = 'rolling_stock_type.mvps',
}

export enum RollingStockTypeRouterEnum {
  nps = 'nps',
  mvps = 'mvps',
}

export enum BlockNameEnum {
  carriageNumerations = 'carriageNumerations',
  maxTrainLength = 'maxTrainLength',
  establishedTrainSchemas = 'establishedTrainSchemas',
  trainChangeDirections = 'trainChangeDirections',
  locomotiveChanges = 'locomotiveChanges',
  locomotiveTeamChanges = 'locomotiveTeamChanges',
  waterSupply = 'waterSupply',
  fuelSupply = 'fuelSupply',
  ecoToilets = 'ecoToilets',
  wasteCollections = 'wasteCollections',
  borderControl = 'borderControl',
  maneuveringWork = 'maneuveringWork',
}

export enum SchemaOperationStationsSearchEnum {
  isBorderControl = 'is_border_control',
  isEcoToilets = 'is_eco_toilets',
  isChangeLocomotive = 'is_change_locomotive',
  isChangeLocomotiveTeam = 'is_change_locomotive_team',
  isFuelSupply = 'is_fuel_supply',
  isWasteCollection = 'is_waste_collection',
  isWaterSupply = 'is_water_supply',
  isManeuverWork = 'is_maneuver_work',
}

export const CARRIAGE_GROUP_BGCOLOR_STATUS_MAP: Readonly<
  Record<string, string>
> = Object.freeze({
  [CarriageGroupStatusMnemonicEnum.pending]: '#f8f8fB',
  [CarriageGroupStatusMnemonicEnum.exported]: '#efefd8',
  [CarriageGroupStatusMnemonicEnum.imported]: '#d0efc2',
});

export const CARRIAGE_GROUP_COLOR_STATUS_MAP: Readonly<Record<string, string>> =
  Object.freeze({
    [CarriageGroupStatusMnemonicEnum.pending]: '#afafaf',
    [CarriageGroupStatusMnemonicEnum.exported]: '#d7d7a4',
    [CarriageGroupStatusMnemonicEnum.imported]: '#63a95d',
  });

export enum CarriageGroupModalEnum {
  header = 'header',
  periodicity = 'periodicity',
  calendar = 'calendar',
  turnover = 'turnover',
  timeStagnation = 'timeStagnation',
  variableTimeStagnation = 'variableTimeStagnation',
  constantTimeStagnation = 'constantTimeStagnation',
  carriageParametersHeader = 'carriageParametersHeader',
  carriagePlace = 'carriagePlace',
  trainParametersHeader = 'trainParametersHeader',
  declineHistoryView = 'declineHistoryView',
}

export enum CarriageGroupSignEnum {
  sign_o = 'О',
  sign_p = 'П',
  sign_b = 'Б',
}

export enum CarriageGroupSignMnemonicEnum {
  sign_o = 'carriage_group_sign.o',
  sign_p = 'carriage_group_sign.p',
  sign_b = 'carriage_group_sign.b',
}

export const CARRIAGE_GROUP_SIGN_MAP: Readonly<Record<string, string>> =
  Object.freeze({
    [CarriageGroupSignMnemonicEnum.sign_o]: CarriageGroupSignEnum.sign_o,
    [CarriageGroupSignMnemonicEnum.sign_p]: CarriageGroupSignEnum.sign_p,
    [CarriageGroupSignMnemonicEnum.sign_b]: CarriageGroupSignEnum.sign_b,
  });

export enum SeatTypeMnemonicEnum {
  sv = 'seat_type.sv',
  coupe = 'seat_type.coupe',
  pl = 'seat_type.pl',
  common = 'seat_type.common',
  other = 'seat_type.other',
}

export enum SortingDirectionEnum {
  asc = 'ASC',
  desc = 'DESC',
}

export enum ExportFilteredTrainListTypeEnum {
  TRAINS = 0,
  FORM,
}

// TODO: временное решение с SyncTrainStatus, переделать на mnemonics
export enum SyncTrainStatus {
  approved = 'sync_train_status.approved',
  not_asu_ms = 'sync_train_status.not_asu_ms',
  not_approved = 'sync_train_status.not_approved',
}

export const SYNC_TRAIN_STATUS_NAME_MAP = {
  [SyncTrainStatus.approved]: 'Да',
  [SyncTrainStatus.not_asu_ms]: 'Нет',
  [SyncTrainStatus.not_approved]: 'Проект',
};
